<template>
  <validation-observer :ref="ref" v-slot="{ validate, pristine, reset }">
    <slot :handleSubmit="handleSubmit" :reset="reset" :validate="validate" :pristine="pristine"></slot>
  </validation-observer>
</template>

<script>
  import {ValidationObserver} from 'vee-validate';

  export default {
    props: ['_ref'],
    components: {ValidationObserver},
    computed: {
      ctx() {
        return this.$refs[this.ref].ctx;
      },
      ref() {
        return this._ref || 'observer';
      }
    },
    methods: {
      async handleSubmit(onSuccess = () => null, onFail = () => null) {
        let observer = this.$refs[this.ref];
        const isValid = await observer.validate();

        console.log({isValid})

        if (!isValid) {
          return onFail();
        }

        await onSuccess();

        await this.$nextTick();
        observer.reset();
      }
    }
  };
</script>

<style scoped>

</style>
